<div id="container">

  <div id="header">
    <app-navbar></app-navbar>
  </div>

  <div id="body">
    <div class="container main-container"
      *ngIf="_portalConfigurationService.configuration?.maintenanceMode && 
      _portalConfigurationService.configuration?.maintenanceMode?.name =='true' &&
      _userService.user?.role != 'superadmin' &&
      !_portalConfigurationService.configuration?.usersForMaintenanceMode?.name.includes(_userService.user?.email)">
      <div class="text-center alert alert-primary"
        *ngIf="_portalConfigurationService.configuration?.textOnMaintenanceMode.name">
        {{_portalConfigurationService.configuration?.textOnMaintenanceMode.name}}
      </div>
      <div class="text-center alert alert-primary"
        *ngIf="!_portalConfigurationService.configuration?.textOnMaintenanceMode.name">
        Portal en Mantenimiento
      </div>
    </div>

    <div class="container main-container"
      *ngIf="!_portalConfigurationService.configuration?.maintenanceMode || 
      _portalConfigurationService.configuration?.maintenanceMode?.name =='false' || 
      _userService.user?.role == 'superadmin' ||
      _portalConfigurationService.configuration?.usersForMaintenanceMode?.name.includes(_userService.user?.email)">
      <router-outlet></router-outlet>
    </div>
  </div>

  <div id="footer">
    <app-footer></app-footer>
  </div>

</div>